// Imports
import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import Sidebar from '../../components/Sidebar';
import Header from '../../components/header';
import Titulo from '../../components/Titulo/titulo';
import { useEducation } from '../../context/educationContext';
import Modal from '../../components/modal';
import FormatedInput from '../../components/FormatdInput/formatFunctions';
import PlusCircle from '../../assets/icons/pluscircle.svg';
import useSubmitLock from '../../utils/useSubmitLock';

const Teachers = () => {
  const { listTeachers, createTeacher } = useEducation();
  const { isSubmitting, runWithSubmitLock } = useSubmitLock();

  // Estados para controle de dados e formulário
  // Dados do professor
  const [teachers, setTeachers] = useState([]);
  const [selectedTeacher, setSelectedTeacher] = useState(null);
  // Controle de modal
  const [showModal, setShowModal] = useState(false);
  // Dados do formulário
  const [formData, setFormData] = useState({
    name: '',
    cpf: '',
    registration: '',
    date_of_birth: '',
    social_name: '',
    nationality: '',
    naturalness: '',
    is_active: true,
  });

  // Função para resetar os campos do formulário
  const resetFormData = () => {
    setFormData({
      name: '',
      cpf: '',
      registration: '',
      date_of_birth: '',
      social_name: '',
      nationality: '',
      naturalness: '',
      is_active: true,
    });
  };

  // Efeitos para carregamento inicial e preenchimento de formulário ao editar
  useEffect(() => {
    const fetchData = async () => {
      const data = await listTeachers();
      if (data && data.results) {
        setTeachers(data.results);
      } else {
        setTeachers([]);
      }
    };
    fetchData();
  }, [listTeachers]);

  useEffect(() => {
    if (selectedTeacher) {
      setFormData({
        name: selectedTeacher.name,
        cpf: selectedTeacher.cpf,
        registration: selectedTeacher.registration,
        date_of_birth: selectedTeacher.date_of_birth,
        social_name: selectedTeacher.social_name,
        nationality: selectedTeacher.nationality,
        naturalness: selectedTeacher.naturalness,
        is_active: selectedTeacher.is_active,
      });
    }
  }, [selectedTeacher]);

  // Função para abrir modal e preencher dados ao visualizar professor
  const handleViewTeacher = (teacherId) => {
    const teacher = teachers.find((t) => t.id === teacherId);
    if (teacher) {
      setSelectedTeacher(teacher);
      setShowModal(true);
    }
  };

  // Função para lidar com envio do formulário
  const handleSubmit = async (e) => {
    e.preventDefault();
    await runWithSubmitLock(async () => {
      if (selectedTeacher) {
        // lógica de atualização futura
      } else {
        await createTeacher(formData);
      }
      const updatedTeachers = await listTeachers();
      if (updatedTeachers && updatedTeachers.results) {
        setTeachers(updatedTeachers.results);
      }
      setShowModal(false);
      setSelectedTeacher(null);
      resetFormData();
    });
  };

  // Função para abrir modal de adicionar professor
  const handleOpenAddTeacher = () => {
    setSelectedTeacher(null);
    resetFormData();
    setShowModal(true);
  };

  return (
    <div>
      <Sidebar />
      <Header />
      <div className="container">
        <Titulo
          children={<h2>Professores</h2>}
          children2={
            <button
              className="btnAdcionar"
              onClick={handleOpenAddTeacher}
            >
              <img src={PlusCircle} alt='icone' /> Cadastrar Professor
            </button>
          }
        />
        <div className="content content-table">
          <table className="teacher-table">
            <thead>
              <tr>
                <th>Nome</th>
                <th>CPF</th>
                <th>Registro</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {teachers.map((teacher) => (
                <tr key={teacher.id}>
                  <td>{teacher.name}</td>
                  <td>{teacher.cpf}</td>
                  <td>{teacher.registration}</td>
                  <td>
                    <button onClick={() => handleViewTeacher(teacher.id)} className="action-button">
                      <FontAwesomeIcon icon={faEye} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <Modal
          isOpen={showModal}
          closeModal={() => {
            setShowModal(false);
            setSelectedTeacher(null);
            resetFormData();
          }}
          title={
            selectedTeacher
              ? `Professor: ${selectedTeacher.name}`
              : 'Adicionar Professor'
          }
        >
          <form onSubmit={handleSubmit}>
            <div className="form-group-large">
              <label>Nome</label>
              <input
                type="text"
                value={formData.name}
                onChange={e => setFormData({ ...formData, name: e.target.value })}
                readOnly={!!selectedTeacher}
                required
              />
            </div>
            <div className="form-group-large">
              <label>Nome Social</label>
              <input
                type="text"
                value={formData.social_name}
                onChange={e => setFormData({ ...formData, social_name: e.target.value })}
                readOnly={!!selectedTeacher}
                required
              />
            </div>
            <div className="form-group">
              <label>CPF</label>
              <FormatedInput
                placeholder="000.000.000-00"
                type="cpf"
                value={formData.cpf}
                onChange={e => setFormData({ ...formData, cpf: e.target.value })}
                readOnly={!!selectedTeacher}
                required
              />
            </div>
            <div className="form-group">
              <label>Registro</label>
              <input
                type="text"
                value={formData.registration}
                onChange={e => setFormData({ ...formData, registration: e.target.value })}
                readOnly={!!selectedTeacher}
                required
              />
            </div>
            <div className="form-group">
              <label>Data de Nascimento</label>
              <input
                type="date"
                value={formData.date_of_birth ? formData.date_of_birth.slice(0, 10) : ''}
                onChange={e => setFormData({ ...formData, date_of_birth: e.target.value })}
                readOnly={!!selectedTeacher}
                required
              />
            </div>
            <div className="form-group">
              <label>Nacionalidade</label>
              <input
                type="text"
                value={formData.nationality}
                onChange={e => setFormData({ ...formData, nationality: e.target.value })}
                readOnly={!!selectedTeacher}
                required
              />
            </div>
            <div className="form-group">
              <label>Naturalidade</label>
              <input
                type="text"
                value={formData.naturalness}
                onChange={e => setFormData({ ...formData, naturalness: e.target.value })}
                readOnly={!!selectedTeacher}
                required
              />
            </div>
            <div className="form-group">
              <label>Status Ativo</label>
              <select
                value={formData.is_active ? 'true' : 'false'}
                onChange={e => setFormData({ ...formData, is_active: e.target.value === 'true' })}
                disabled={!!selectedTeacher}
                required
              >
                <option value="true">Sim</option>
                <option value="false">Não</option>
              </select>
            </div>
            {!selectedTeacher && (
              <button type="submit" className="btnAdcionar" disabled={isSubmitting}>
                {isSubmitting ? 'Salvando...' : 'Salvar'}
              </button>
            )}
          </form>
        </Modal>
      </div>
    </div>
  );
};

export default Teachers;
